/** Simple date range picker used when period='custom'. */
export default function CustomDateRange({ start, end, onChange }) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-xs text-muted-foreground">De</span>
      <input
        type="date" value={start || ""}
        onChange={(e) => onChange({ start: e.target.value, end })}
        className="px-2 py-1.5 rounded-lg border border-border bg-card text-sm"
        data-testid="custom-start"
      />
      <span className="text-xs text-muted-foreground">Até</span>
      <input
        type="date" value={end || ""}
        onChange={(e) => onChange({ start, end: e.target.value })}
        className="px-2 py-1.5 rounded-lg border border-border bg-card text-sm"
        data-testid="custom-end"
      />
    </div>
  );
}
